import React from 'react';

// Styles live in public/assets/css/theme.css (".app-loader", ".app-progress", ".skeleton-*").

interface Props {
    size?: string;
    showText?: boolean;
    text?: string;
}

// Full-area loader for pages and panels.
export const MyRingLoader: React.FC<Props> = ({ size = '60vh', showText = true, text = 'Loading…' }) => {
    return (
        <div className="app-loader" style={{ minHeight: size }} role="status" aria-live="polite">
            <span className="app-loader-ring" />
            {showText && <span className="app-loader-text">{text}</span>}
        </div>
    )
}

// Compact indeterminate bar for inline and small areas.
export const MyBarLoader: React.FC<Props> = ({ size = '10vh', showText, text = 'Loading…' }) => {
    return (
        <div className="app-loader app-loader-inline" style={{ minHeight: size }} role="status" aria-live="polite">
            <span className="app-progress"><span /></span>
            {showText && <span className="app-loader-text">{text}</span>}
        </div>
    )
}

// Kept for existing imports; renders the compact ring.
export const MyFadeLoader: React.FC<Props> = ({ size = '10vh', showText = false, text }) => {
    return <MyRingLoader size={size} showText={showText} text={text} />
}

interface SkeletonRowsProps {
    columns: number;
    rows?: number;
}

// Placeholder table rows shown while a table's data is loading.
export const SkeletonRows: React.FC<SkeletonRowsProps> = ({ columns, rows = 6 }) => {
    return (
        <>
            {Array.from({ length: rows }).map((_, r) => (
                <tr key={r} className="skeleton-row" aria-hidden="true">
                    {Array.from({ length: columns }).map((_, c) => (
                        // Vary widths so the placeholder reads like real content.
                        <td key={c}>
                            <span className="skeleton-bar" style={{ width: `${45 + ((r * 7 + c * 13) % 45)}%` }} />
                        </td>
                    ))}
                </tr>
            ))}
        </>
    )
}
